/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { Container, Box, Typography, Tab } from "@mui/material";
import React from "react";
import { TabContext, TabList, useTabContext } from "@mui/lab";
import NewParentChildOption from "../../../../components/Product/ParentChild/NewParentChildOption";
import NewParentChild from "../../../../components/Product/ParentChild/NewParentChild";

import ListParentChild from "../../../../components/Product/ParentChild/ListParentChild";
import ListParentChildOption from "../../../../components/Product/ParentChild/ListParentChildOption";
import { useLocation } from "react-router-dom";

import { LogTrackUser } from "../../../../types/log-track-user/log-track-user";
import Cookies from "js-cookie";
function TabPanel(props: any) {
  const { children, className, value, index, ...other } = props;

  const context = useTabContext();

  if (context === null) {
    throw new TypeError("No TabContext provided");
  }
  const tabId = context.value;

  return (
    <Typography
      component="div"
      role="tabpanel"
      padding="24px"
      hidden={value !== tabId}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //visibility={value === tabId ? "visible" : "hidden"}
      {...other}
    >
      {children}
    </Typography>
  );
}

export default function ProductsParentChild() {
  const [tabValue, setTabValue] = useState("1");
  //User Tracking Logging Section //////////////////////////////////////
  let [alreadySetLog, setAlreadySetLog] = useState(false);
  const location = useLocation();
  if (!alreadySetLog) {
    LogTrackUser(Cookies.get("username"), location.pathname);
    setAlreadySetLog(true as boolean);
  }
  ///////////////////////////////////////////////////////////////////
  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };
  return (
    <Container
      component="main"
      maxWidth="xl"
      sx={{
        marginTop: 4,
      }}
    >
      <div>
        <TabContext value={tabValue}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              maxWidth: "xl",
              minWidth: 3 / 4,
            }}
          >
            <TabList onChange={handleChangeTab} centered aria-label="Tabs">
              <Tab label="List Products Parent Child" value="1" />
              <Tab label="New Products Parent Child" value="2" />
              <Tab label="List Product Parent Child Options" value="3" />
              <Tab label="New Product Parent Child Option" value="4" />
            </TabList>
          </Box>
          <TabPanel
            value="1"
            sx={{
              width: "100%",
              typography: "body1",
              maxWidth: "xl",
              minWidth: 4 / 4,
              alignItems: "center",
            }}
          >
            <ListParentChild />
          </TabPanel>
          <TabPanel
            value="2"
            sx={{
              width: "100%",
              typography: "body1",
              maxWidth: "xl",
              minWidth: 4 / 4,
              alignItems: "center",
            }}
          >
            <NewParentChild />
          </TabPanel>
          <TabPanel
            value="3"
            sx={{
              width: "100%",
              typography: "body1",
              maxWidth: "xl",
              minWidth: 4 / 4,
              alignItems: "center",
            }}
          >
            <ListParentChildOption />
          </TabPanel>
          <TabPanel
            value="4"
            sx={{
              width: "100%",
              typography: "body1",
              maxWidth: "xl",
              minWidth: 4 / 4,
              alignItems: "center",
            }}
          >
            <NewParentChildOption />
          </TabPanel>
        </TabContext>
      </div>
    </Container>
  );
}
